
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import glossaryUsageDescriptor from './GlossaryUsageDescriptor.json'
import GlossaryUsageInfoDialogWordsColumnList from './GlossaryUsageInfoDialogWordsColumnList.vue'

export default defineComponent({
    name: 'glossary-usage-info-dialog',
    components: { Dialog, GlossaryUsageInfoDialogWordsColumnList },
    emits: ['close'],
    props: {
        visible: { type: Boolean },
        contentInfo: { type: Object },
        selectedWords: { type: Array }
    },
    data() {
        return {
            glossaryUsageDescriptor
        }
    }
})
